'use strict';

angular.module('far.camp')
    .controller('DescriptionCampController', function ($log,
                                                  $http,
                                                  $window,
                                                  $timeout,
                                                  $q,
                                                  pagination) {
        var vm = {
            constructor: constructor,
            type: 5,
            camp:[],
            campId: null,
            data:""
        };

        function constructor(campId) {
            vm.campId = campId;
                 return $http.get(Routing.generate('api_get_camp', {
                camp_id: vm.campId
                
            })).then(function (response) {
                var items = [];
                vm.totalPages = Math.ceil(response.headers('X-Total-Count') / count);

                angular.forEach(response.data, function (item) {
                    camp.push(item);
                });
                console.log(response.data);

               console.log(camp);
            }).catch(function (response) {
                $log.error(response);
                return $q.reject(response);
            });
            
        }

  
        //nextPage();

        return vm;
    });